import { Box, IconButton } from '@mui/material';
import React from 'react';
import {
  CARD_FOOTER_PADDING_BOTTOM,
  CARD_FOOTER_PADDING_TOP,
  CARD_LINK_STRETCH,
  PROPERTY_CARD_EQUAL_HEIGHT,
} from 'DesignTokens';
import StyledCardLink, { ArrowIcon, StyledSvg } from '../styles/StyledCardLink';

interface PropertyCardFooterProps {
  mini: boolean;
  processedDescription: string | undefined;
  linkable: boolean | undefined;
  expandable: boolean | undefined;
  forceExpanded: boolean | undefined;
  hasTruncatedText: boolean;
  isExpanded: boolean;
  onLinkClick: () => void;
  onToggleExpand: () => void;
}

export default function PropertyCardFooter({
  mini,
  processedDescription,
  linkable,
  expandable,
  forceExpanded,
  hasTruncatedText,
  isExpanded,
  onLinkClick,
  onToggleExpand,
}: PropertyCardFooterProps) {
  const showExpandControl =
    processedDescription &&
    processedDescription.trim().length > 10 &&
    expandable !== false &&
    forceExpanded === undefined &&
    hasTruncatedText;

  if (!showExpandControl && !linkable) {
    return null;
  }

  return (
    <Box
      sx={{
        px: mini ? 1.5 : 2,
        pt: mini ? CARD_FOOTER_PADDING_TOP.mini : CARD_FOOTER_PADDING_TOP.default,
        pb: mini ? CARD_FOOTER_PADDING_BOTTOM.mini : CARD_FOOTER_PADDING_BOTTOM.default,
        mt: PROPERTY_CARD_EQUAL_HEIGHT ? 'auto' : undefined,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: linkable ? 'space-between' : 'center',
      }}
    >
      {linkable && (
        <Box sx={{ flex: CARD_LINK_STRETCH ? 1 : undefined, mr: 1 }}>
          <StyledCardLink
            padding={0}
            onClick={onLinkClick}
            text="Find Out More"
            showArrow={false}
          />
        </Box>
      )}
      {showExpandControl && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onToggleExpand();
          }}
          sx={{
            p: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            '&:hover': { backgroundColor: 'transparent' },
          }}
        >
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)',
              transition: 'transform 0.2s ease-in-out',
            }}
          >
            <ArrowIcon style={{ paddingRight: '0.3125rem' }}>
              <StyledSvg />
            </ArrowIcon>
          </Box>
        </IconButton>
      )}
    </Box>
  );
}
